import { buildApp } from '../app';
import BrandSwitcher from './BrandSwitcher';
import { applyPreMountPolicy } from './brandHint';

applyPreMountPolicy();
buildApp(BrandSwitcher, {});
